var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajorAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 11.1383H10.375V5.82577C10.375 3.62108 8.74531 1.7992 6.625 1.49608V0.888268C6.625 0.542955 6.34531 0.263268 6 0.263268C5.65469 0.263268 5.375 0.542955 5.375 0.888268V1.49608C3.25469 1.7992 1.625 3.62108 1.625 5.82577V11.1383H1.25C0.973438 11.1383 0.75 11.3617 0.75 11.6383V12.1383C0.75 12.207 0.80625 12.2633 0.875 12.2633H4.25C4.25 13.2289 5.03438 14.0133 6 14.0133C6.96563 14.0133 7.75 13.2289 7.75 12.2633H11.125C11.1938 12.2633 11.25 12.207 11.25 12.1383V11.6383C11.25 11.3617 11.0266 11.1383 10.75 11.1383ZM6 13.0133C5.58594 13.0133 5.25 12.6773 5.25 12.2633H6.75C6.75 12.6773 6.41406 13.0133 6 13.0133ZM2.75 11.1383V5.82577C2.75 4.95702 3.0875 4.14139 3.70156 3.52733C4.31563 2.91327 5.13125 2.57577 6 2.57577C6.86875 2.57577 7.68438 2.91327 8.29844 3.52733C8.9125 4.14139 9.25 4.95702 9.25 5.82577V11.1383H2.75Z",
    fill: "#FA541C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorAlarmIcon);
export default __webpack_public_path__ + "static/media/majorAlarmIcon.c3c180ce37f513e59e92d24151738a24.svg";
export { ForwardRef as ReactComponent };